import { camelizeKeys } from "lib/helpers";
import { api } from "rdx/services/api";

export type ZipCoverageT = {
  state: string | null;
  country: string | null;
  city: string | null;
  available: boolean;
  batteryAvailable: boolean;
};

type ZipCoverageApiResponseT = {
  body: {
    state: string | null;
    country: string | null;
    city: string | null;
    available: boolean;
    battery_available: boolean;
  };
};

export const zipsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getZipCoverage: builder.query<ZipCoverageT, string>({
      query: (zip) => ({ url: `zips/${zip}` }),
      transformResponse: (response: ZipCoverageApiResponseT) => camelizeKeys(response.body) as ZipCoverageT,
    }),
  }),
});

export const { useGetZipCoverageQuery } = zipsApi;
